import { FullPageTemplate, FullPageTemplateProps } from '@wrisk/ui-components'
import React from 'react'

import { Footer } from './Footer'

export type FullPageProps = Omit<FullPageTemplateProps, 'footer'>

export const FullPage = (props: FullPageProps) => (
  <FullPageTemplate {...props} footer={<Footer />} />
)
